<template>
  <div class="fapiao-wrap">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="发票信息" name="first">
        <ul class="fapiao-info" v-if="fapiaoInfo">
          <li>
            <label>企业名称：</label>
            <span class="cont">{{faPiaoForm.cmpname}}</span>
          </li>
          <li>
            <label>统一社会信用代码：</label>
            <span class="cont">{{faPiaoForm.buslicno}}</span>
          </li>
          <li>
            <label>营业执照注册地址：</label>
            <span class="cont">{{faPiaoForm.adress}}</span>
          </li>
          <li>
            <label>固定电话：</label>
            <span class="cont">{{faPiaoForm.sitcomp}}</span>
          </li>
          <li>
            <label>对公账户开户行：</label>
            <span class="cont">{{faPiaoForm.bankinfo}}</span>
          </li>
          <li>
            <label>对公账号：</label>
            <span class="cont">{{faPiaoForm.pubaccout}}</span>
          </li>
          <li>
            <label>联系人：</label>
            <span class="cont">{{faPiaoForm.linman}}</span>
          </li>
          <li>
            <label>联系电话：</label>
            <span class="cont">{{faPiaoForm.linephone}}</span>
          </li>
          <li>
            <label>通信地址：</label>
            <span class="cont">{{faPiaoForm.mailadd}}</span>
          </li>
          <li>
            <label>通信邮箱地址：</label>
            <span class="cont">{{faPiaoForm.invmailadd}}</span>
          </li>
          <li>
            <label></label>
            <span class="cont op-submit">
              <el-button size="medium" type="danger" @click="editVisible">去修改</el-button>
            </span>
          </li>
        </ul>

        <editForm v-if="editShow"></editForm>

      </el-tab-pane>
      <el-tab-pane label="开票记录" name="second">开票记录</el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import editForm from './FaPiaoEdit.vue'
import auth from '@/utils/auth'
import utils from '@/utils/utils'
import { GetCompany } from '@/api/company'
export default {
  name: 'FaPiao.vue',
  data() {
    return {
      activeName: 'first',
      editShow: false,
      fapiaoInfo: true,
      faPiaoForm: {},
      compid: ''
    }
  },
  components: {
    editForm
  },
  created() {
    this.compid = auth.getcmpid()
    this.getData()
  },
  methods: {
    // 打开修改
    editVisible() {
      this.editShow = true
      this.fapiaoInfo = false
    },
    // 加载数据
    getData() {
      var self = this
      GetCompany({
        uuid: self.compid,
        sessionToken: auth.getToken()
      })
        .then(res => {
          if (res.code == 20000) {
            self.faPiaoForm = res.data
          }
        })
        .catch(res => {
          // this.$message("请与管理员联系");
        })
    }
  }
}
</script>

<style>
.fapiao-wrap {
  padding: 20px 40px;
}
.fapiao-wrap .el-tabs__item {
  background-color: #f2f2f2;
}
.fapiao-wrap .el-tabs__item.is-active,
.fapiao-wrap .el-tabs__item:hover {
  color: #f54737;
  font-weight: bold;
}
.fapiao-wrap .is-active {
  background-color: #fff;
}
.fapiao-wrap .fapiao-info,
.fapiao-wrap .fapiao-edit {
  margin: 30px 0 0 15px;
}
.fapiao-info li {
  padding: 8px 0;
}
.fapiao-info label {
  display: inline-block;
  width: 150px;
  padding-right: 10px;
  text-align: right;
  color: #777;
}
.fapiao-info .cont {
  display: inline-block;
}
.fapiao-info .op-submit {
  margin-top: 15px;
}
.fapiao-info .op-submit .el-button {
  padding: 10px 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/FaPiao.vue